export default {
    langType: '簡體',
    public_head: {
        home: '首頁',
        cart: '購物車',
        account_setting: '賬户設置',
        categories: '所有類別',
        coffee: '迅貓啡',
        hotsale: '熱賣商品',
        special_offer: '特惠活動',
        machine_location: '機台位置',
        about_us: '關於我們',
        contact_us: '聯繫我們',
        please_sign: '你好，請登錄',
        register: '免費註冊',
        welcome: '歡迎您，',
        personal_center: '個人中心',
        logout: '退出賬號',
        favorites: '收藏夾',
        help_center: '幫助中心',
        macao: '中國澳門',
        mainland: '中國大陸',
        tips: '温馨提示',
        tips_content: '確認退出賬號嗎？',
        cancel_text: '取消',
        confirm_text: '確定',
        points_mall: '積分商城',
        card_buy: '超值卡'
    },
    goods: {
        settle: '去結算',
        add_cart: '加入購物車',
        no_data: '暫無獲取到相對應數據！',
        Recommended_products: '推薦商品',
        more: '查看更多',
        limit_buy: '立即搶購',
        sold_out: '已售空',
        all_goods: '所有商品',
        classify: '分類',
        brand: '品牌',
        stock: '庫存',
        unit: '件',
        integral: '積分'
    },
    merchant_promise: {
        text1: '百萬用户口碑',
        text2: '品牌防偽碼',
        text3: '值得信賴品牌',
        text4: '品類齊全',
        text5: '精緻服務',
        text6: '天天特價'
    },
    pay: {
        payment_method: '選擇支付方式',
        hide_payment_methode_: '收起支付方式',
        more_payment_method: '更多支付方式',
        payment: '立即支付'
    },
    public_footer: {
        text1: '品牌真品防偽碼',
        text2: '專屬客服服務 853-63005007',
        text3: '© 2009-2022 迅貓先鋒 版權所有 ',
        link: '粵ICP備2021154733號'
    },
    forget: {
        forgot_pwd: '忘記密碼',
        phone: '手機號碼',
        your_phone_tips: '請輸入你的手機號碼',
        phone_tips: '請輸入手機號碼',
        phone_regular_tips: '請輸入正確的手機號碼',
        code: '驗證碼',
        code_tips: '請輸入驗證碼',
        get_code: '獲取驗證碼',
        sent: '已發送',
        new_pwd: '新密碼',
        confirm_pwd: '密碼確認',
        edit_pwd: '修改密碼',
        pwd_tips: '請輸入密碼',
        pwd_regular_tips: '請輸入6-18位字母、數字組合!',
        pwd_confirm_tips: '請再次輸入密碼',
        pwd_confirm_check_tips: '兩次輸入密碼不一致',
        reset_pwd: '密碼重置完成，前往登錄',
        tips: '温馨提示',
        cancel_text: '取消',
        confirm_text: '確定',
    },
    login: {
        pwd_login: '密碼登錄',
        code_login: '短信登錄',
        scan_code_login: '微信掃碼登錄',
        phone: '手機號碼',
        phone_tips: '請先輸入手機號碼',
        code_tips: '請輸入驗證碼',
        get_code: '獲取驗證碼',
        pwd_tips: '請輸入密碼',
        login: '登錄',
        protocol_text1: '登錄代表您已同意',
        protocol_text2: '《迅貓先鋒用户協議》',
        protocol_text3: '和',
        protocol_text4: '《隱私協議》',
        forget_pwd: '忘記密碼',
        register: '免費註冊',
        phone_regular_tips: '請輸入正確的手機號碼',
        sent: '已發送',
    },
    register: {
        user_register: '用户註冊',
        phone: '手機號碼',
        your_phone_tips: '請輸入你的手機號碼',
        phone_tips: '請輸入手機號碼',
        phone_regular_tips: '請輸入正確的手機號碼',
        code: '驗證碼',
        code_tips: '請輸入驗證碼',
        get_code: '獲取驗證碼',
        sent: '已發送',
        pwd: '密碼',
        confirm_pwd: '密碼確認',
        pwd_tips: '請輸入密碼',
        protocol_text1: '註冊代表您已同意',
        protocol_text2: '《迅貓先鋒用户協議》',
        protocol_text3: '和',
        protocol_text4: '《隱私協議》',
        protocol_text5: '同意並註冊',
        pwd_regular_tips: '請輸入6-18位字母、數字組合!',
        pwd_confirm_tips: '請再次輸入密碼',
        pwd_confirm_check_tips: '兩次輸入密碼不一致',
        register_success_tips: '註冊成功，前往登錄?',
        tips: '温馨提示',
        cancel_text: '取消',
        confirm_text: '確定',
    },
    cart: {
        home: '首頁',
        shop_cart: '購物車',
        title_row1: '商品信息',
        title_row2: '單價',
        title_row3: '數量',
        title_row4: '金額',
        title_row5: '操作',
        original_price: '原價',
        delete: '刪除',
        empty: '清空購物車',
        allselect: '全選',
        total: '合計',
        settle: '結算',
        select_tips: '請選擇商品',
        modal_text1: '確認清空購物車嗎?',
        modal_text2: '確認將該商品移除購物車嗎?',
        tips: '温馨提示',
        cancel_text: '取消',
        confirm_text: '確定',
        go_to_mall: '前往商城',
        empty_tips: '主人，您的購物車還沒有商品喲~',
        vemid: '設備ID'
    },
    machine: {
        home: '首頁',
        machine_location: '機台位置',
        location: '導航',
        cart: '購物車',
        back: '返      回',
        no_data: '暫無獲取到相對應數據！',
        area: '區域',
        default: '默認',
        distance_text1: '由遠到近',
        distance_text2: '由近到遠',
        all: '全部',
        vending_machine: '售賣機',
        coffee_machine: '迅貓啡',
        machine_no: '機器編號'
    },
    member: {
        member_card_number: '會員卡號',
        my_order: '我的訂單',
        order_text1: '所有訂單',
        order_text2: '待付款',
        order_text3: '待自提',
        order_text4: '已取消',
        order_text5: '已完成',
        btn_tit: '常用功能',
        btn_text1: '積分商城',
        btn_text2: '我的收藏',
        btn_text3: '聯繫客服',
        btn_text4: '關於我們',
        btn_text5: '退出賬號',
        btn_text6: '我的卡包',
        tips: '温馨提示',
        tips_content: '確認退出賬號嗎？',
        cancel_text: '取消',
        confirm_text: '確定',
        coupon: '我的優惠券',
        coupon_title: '優惠券',
        points: '積分'
    },
    member_info: {
        basic_info: '基礎資料',
        avatar: '頭像',
        nickname: '暱稱',
        nickname_tips: '請輸入暱稱',
        sex: '性別',
        unknown: '未知',
        male: '男',
        female: '女',
        security_settings: '安全設置',
        user_account: '用户賬號',
        login_pwd: '登錄密碼',
        edit_pwd: '修改密碼',
        phone: '手機號碼',
        change_tie: '換綁',
        save: '保存',
        reset_pwd: '重置密碼',
        phone_tips: '請輸入手機號碼',
        code: '驗證嗎',
        get_code: '獲取驗證碼',
        sent: '已發送',
        pwd: '密碼',
        confirm_pwd: '密碼確認',
        protocol_text1: '登錄代表您已同意',
        protocol_text2: '《迅貓先鋒用户協議》',
        protocol_text3: '和',
        protocol_text4: '《隱私協議》',
        change_tie_phone: '換綁手機',
        your_phone_tips: '請輸入你的手機號碼',
        previous: '上一步',
        next_step: '下一步',
        pwd_tips: '請輸入密碼',
        pwd_confirm_tips: '請再次輸入密碼',
        pwd_confirm_check_tips: '兩次輸入密碼不一致',
        phone_check_tips: '請輸入正確的手機號碼',
        upload_tips: '只能上傳 jpeg/jpg/png 格式文件',
        tips: '温馨提示',
        tips_content: '密碼重置完成，請重新登錄賬號',
        cancel_text: '取消',
        confirm_text: '確定',
    },
    user_order: {
        title_row1: '商品',
        title_row2: '單價',
        title_row3: '數量',
        title_row4: '商品操作',
        title_row5: '實付款',
        title_row6: '交易狀態',
        title_row7: '交易操作',
        orderno: '訂單號',
        self_code: '自提碼',
        distance: '距離',
        original_price: '原價',
        redemption_code: '兑換碼',
        Including_shipping: '含運費',
        states_text1: '待付款',
        states_text2: '待自提',
        states_text3: '配送中',
        states_text4: '已完成',
        states_text5: '已取消',
        states_text6: '退款/售後',
        order_detail: '訂單詳情',
        settle: '去結算',
        cancel_order: '取消訂單',
        delete_order: '刪除訂單',
        no_related_orders: '暫無相關訂單',
        empty_tips: '主人，您近期還沒有購買任何商品喲~',
        empty_btn: '前往商城',
        code_text1: '請截圖保存下方取貨兑換碼',
        code_text2: '並且30天內到已選定的機台取貨',
        code_text3: '兑換碼',
        payments: '支付進行中',
        view_order_detail: '查看訂單詳情',
        tips: '温馨提示',
        cancel_tips: '確認取消該訂單嗎？',
        delete_tips: '確認刪除該訂單嗎？',
        refund_tips: '確認退款該訂單嗎？',
        cancel_text: '取消',
        confirm_text: '確定',
        point: '積分',
        refund_status: '退款狀態',
        exchange: '兑換',
        has_been: '已於',
        vemid: '設備ID'
    },
    help: {
        home: '首頁',
        help_center: '幫助中心'
    },
    order_confirm: {
        checkout_page: '結算頁',
        fill_tips: '填寫並核對訂單信息',
        default: '默認',
        paytype: '支付方式',
        goods_list: '商品清單',
        putaway: '收起',
        expand: '展開',
        original_price: '原價',
        amount: '商品金額',
        total: '實付款',
        payments: '支付中…',
        settle: '去結算',
        payments_progress: '支付進行中',
        view_order_detail: '查看訂單詳情',
        pickup: '自提',
        coupon: '優惠券',
        edit: '修改',
        coupon_available: '張可用',
        no_available: '暫無可用',
        no_use: '不使用優惠券',
		validity_period: '有效期至',
		full_text: '滿',
		available: '可用',
        select_coupon: '選擇優惠券',
        pay_tips: '如無法正常支付，請檢查您的瀏覽器設置，是否攔截彈窗，請修改設定後回到訂單頁面嘗試重新支付，如仍有問題，請及時與我們客服工作人員聯繫，感謝您的配合與諒解。',
        integral: ' 積分',
        paypoint: '支付積分',
        card_txt1: '是否贈送好友',
		card_txt2: '是',
		card_txt3: '否',
		card_txt4: '填寫好友會員手機號',
		card_txt5: '請輸入手機號'
    },
    order_detail: {
        title: '訂單詳情',
        order_status: '訂單狀態',
        status_text1: '待付款',
        status_text2: '待自提',
        status_text3: '配送中',
        status_text4: '已完成',
        status_text5: '已取消',
        status_text6: '退款/售後',
        distance: '距離',
        goods_list: '商品清單',
        redemption_code: '兑換碼',
        putaway: '收起',
        expand: '展開',
        code_text1: '請截圖保存下方取貨兑換碼',
        code_text2: '並且24小時內到已選定的機台取貨',
        code_text3: '兑換碼',
        code_text4: '並且30天內到已選定的機台取貨',
        payment_method: '支付方式',
        delivery_method: '配送方式',
        home_delivery: '配送上門',
        pickup: '售賣機自提',
        orderno: '訂單編號',
        orderno_time: '下單時間',
        pay_time: '支付時間',
        amount: '商品金額',
        payable: '需付款',
        total: '實付款',
        settle: '去結算',
        cancel_order: '取消訂單',
        payments: '支付進行中',
        view_order_detail: '查看訂單詳情',
        tips: '温馨提示',
        cancel_tips: '確認取消該訂單嗎？',
        refund_tips: '確認退款該訂單嗎？',
        cancel_text: '取消',
        confirm_text: '確定',
        not_order: '訂單不存在',
        coupon: '優惠券',
        point: '積分',
        refund_status: '退款狀態',
        exchange: '兑換',
        has_been: '已於',
        refund_status_text: '退款審核狀態',
		refund_pay_text: '退款到賬狀態',
		refund_amount: '退款金額',
        integral: ' 積分',
        paypoint: '支付積分',
        vemid: '設備ID',
        close: '關閉',
        send_friend: '贈送好友',
        card_num1: ' 總數量',
		card_num2: ' 待兌換數量',
		card_change: ' 切換'
    },
    coupon: {
        validity_period: '有效期至',
		full_text: '滿',
		available: '可用',
		receive: '立即領取',
		receive_success: '領取成功',
		settle: '去結算',
		sold_out: '已售空',
        use_desc: '使用描述'
    },
    goods_info: {
        home: '首頁',
        goods_detail: '商品詳情',
        all_goods: '所有商品',
		notice: '購物須知',
		add_cart: '加入購物車',
		buy: '立即購買',
		stock: '庫存',
		unit: '件',
		num: '數量',
		confirm_text: '確認',
		select_text: '已選',
		unfold: '展開',
		pickup: '收起',
		vend_title: '售賣機',
		location: '導航',
		notice_content: '商品的實際標價，不因表達的差異改變性質。具體的成交價格根據商品參加活動，或會員使用優惠券、積分等發生變化最終以訂單結算頁價格為準。',
		time_limit_title: '限時購',
		time_limit_desc: '限時限量，速速搶購',
		time_limit_tips_start: '距開始僅剩',
		time_limit_tips_conduct: '距結束僅剩',
		time_limit_tips_end: '已結束',
		limit_buy: '立即搶購',
		sale_out: '已售空',
        wechat_scan: '微信掃一掃',
        go_to_mall: '前往商城',
        hot_sale: '熱賣商品',
        does_not_exist: '訪問的商品不存在~',
        integral: '積分'
	},
    coupon_list: {
		title: '優惠券',
		coupon_state: [{
			states: 0,
			name: '未使用'
		},{
			states: 1,
			name: '已使用'
		},{
			states: 2,
			name: '已過期'
		}],
		loading: '正在加載中',
		nomore: '已經到底了！',
		none_order: '您還沒有相關的優惠券',
		desc_text1: '消費滿',
		desc_text2: '可用，可減免',
		use_btn: '去使用',
        expired_btn: '已過期',
        use_desc: '使用描述',
        used_btn: '已使用',
		coupon_desc1: '有效期至',
		coupon_desc2: '自助機（自提）可用',
		coupon_desc3: '最終解釋權歸迅貓先鋒所有',
        no_coupon: '暫無相關優惠券',
        all_available: '全場可用',
        part_available: '指定商品可用'
	},
    goods_collect: {
        home: '首頁',
        favorites: '收藏夾',
        remove_favorite: '移除收藏夾',
        cancel_batch_management: '取消批量管理',
        batch_management: '批量管理',
        empty_favorites: '清空收藏夾',
        all_select: '全選',
        go_to_mall: '前往商城',
        empty_tips: '主人，您還沒有收藏過任何商品喲~',
        tips: '温馨提示',
        clear_tips_content: '確認清空收藏夾嗎?',
        remove_tips_content: '確認將選中的商品移除收藏夾嗎?',
        cancel_text: '取消',
        confirm_text: '確定',
	},
    points: {
        user_center: '個人中心',
        points_mall: '積分商城',
        integral: '積分',
        exchange: '兑換',
        tips: '温馨提示',
		tips_content: '確認兑換該商品嗎？',
		cancel_text: '取消',
		confirm_text: '確定',
        no_data: '暫無獲取到相對應數據！',
        exchange_record: '兑換記錄',
		check: '查看',
    },
    record: {
        integral_detail: '積分明細',
        exchange_record: '兑換記錄',
		rule_desc: '查看規則説明',
		order: '訂單編號',
		addtime: '創建時間',
        integral: '積分',
        no_data: '暫無獲取到相對應數據！'
    },
    integral_detail: {
        home: '首頁',
		points_mall: '積分商城',
		integral: '積分',
		stock: '庫存數量',
		exchange: '馬上兑換',
		rule: '兑換規則',
		more: '查看更多',
		pickup: '收起',
		unfold: '展開',
		detail: '商品詳情',
		unit: '件',
		tips: '温馨提示',
		tips_content: '確認兑換該商品嗎？',
		cancel_text: '取消',
		confirm_text: '確定',
		vend_title: '售賣機',
		location: '導航'
	},
    card: {
		title: '月卡購買',
		detail_title: '詳情',
		validity: '有效期',
		day: '天',
		number: '剩餘次數',
		times: '次',
		my_card: '我的卡包',
		use_txt1: '已使用',
		use_txt2: '未使用',
		use_txt3: '去使用',
		pop_txt1: '選擇咖啡機',
        value: '價值'
	}
}